var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7C6.5 3.13401 9.63401 0 13.5 0C17.366 0 20.5 3.13401 20.5 7C20.5 10.866 17.366 14 13.5 14H11.5V16H9.5V18H7.5V20H0.5V14.5858L6.64801 8.43778C6.54995 7.96847 6.5 7.48731 6.5 7ZM9.5 14V12H13.5C16.2614 12 18.5 9.76142 18.5 7C18.5 4.23858 16.2614 2 13.5 2C10.7386 2 8.5 4.23858 8.5 7C8.5 7.49863 8.57269 7.98638 8.71408 8.45287L8.88789 9.02633L2.5 15.4142V18H5.5V16H7.5V14H9.5ZM11.5 7C11.5 8.10457 12.3954 9 13.5 9C14.6046 9 15.5 8.10457 15.5 7C15.5 5.89543 14.6046 5 13.5 5C12.3954 5 11.5 5.89543 11.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.2969a28b.svg";
export { ForwardRef as ReactComponent };